import axios from "axios";

const POR_API_BASE = "https://api-por-data.primuslabs.xyz/por-api";

export const UNITAS_PROJECT_ID = "2009468028521021440";
export const UNITAS_XGLD_PROJECT_ID = "2059178549897592832";
export const RWALPHA_PROJECT_ID = "2071833265605443584";

export function getDashboardCard(projectId) {
  return axios({
    method: "GET",
    url: `${POR_API_BASE}/por/dashboard/card`,
    headers: {
      "por-project-id": projectId,
    },
  }).then((response) => response.data);
}
